import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ScrollService } from './app/shared/services/scroll/scroll.service';
import AOS from 'aos';
import 'aos/dist/aos.css';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
  ],
})
  .then((appRef) => {
    const scrollService = appRef.injector.get(ScrollService);
    scrollService.initScrollBehavior();

    AOS.init({
      duration: 800,      // Animation duration in ms
      easing: 'ease-out', // Easing type
      once: true,         // Animate only once
      offset: 100,        // Offset (px) before triggering animation
    });
  })
  .catch((err) => console.error(err));
